import {useState, useCallback, useRef} from 'react';
import IntegrationConfigListView from './list';
import IntegrationConfigCreateOrUpdateView from './form';
import {useIntegrationConfig} from './queries';
import {useIntegrations, withCredential} from '../integration/queries';
import {IntegrationConfig} from 'src/core/data/api/IntegrationConfig';

export type ViewType = 'list' | 'create' | 'edit';

const IntegrationConfigContainer = () => {
  const {data: integrationConfig, isFetching: fetching} = useIntegrationConfig();
  const {data: rawIntegrations, isFetching: isFetchingIntegrations} = useIntegrations();
  const integrations = withCredential(rawIntegrations);

  const selectedIntegrationConfigOnViewChange = useRef<IntegrationConfig>();

  const [activeView, setActiveView] = useState<ViewType>('list');

  const setSelectedIntegrationConfigOnViewChange = (data?: IntegrationConfig) => {
    selectedIntegrationConfigOnViewChange.current = data;
  };

  const onViewChange = useCallback(
    (viewName: ViewType, integration?: IntegrationConfig) => {
      setSelectedIntegrationConfigOnViewChange(integration);
      setActiveView(viewName);
    },
    [],
  );

  const views = {
    list: <IntegrationConfigListView integrationConfigs={integrationConfig} loading={fetching} onViewChange={onViewChange} />,
    create: <IntegrationConfigCreateOrUpdateView
      onViewChange={onViewChange}
      integrations={integrations}
      isFetchingIntegrations={isFetchingIntegrations}
    />,
    edit: <IntegrationConfigCreateOrUpdateView
      selectedIntegrationConfig={selectedIntegrationConfigOnViewChange.current}
      onViewChange={onViewChange}
      integrations={integrations}
      isFetchingIntegrations={isFetchingIntegrations}
    />,
  };

  return views[activeView];
};

export default IntegrationConfigContainer;
